import React, {Component} from 'react';
import {Input, Card, Pagination, Icon, Popconfirm, message,Modal, Button, Form, Spin,Upload,Switch,InputNumber,Radio} from 'antd';
import {uuid} from "../../../utils";
import BaseComponent from "../../../base/BaseComponent";
import BaseTable from "../../../view/components/baseTable/BaseTable";
import {HEADER_HEIGHT, ONLY_PIC_TYPE_NEW} from "../../../constants";
import {Scrollbars} from "react-custom-scrollbars";

const {Search} = Input;
class Splash extends BaseComponent {

    constructor(props) {
        super(props);
    }

    columns = [
        {
            title: '图片',
            dataIndex: 'storageUrl',
            key: 'storageUrl',
            render: (text, record) => (
                <img src={text} height={100} width={100} style={{objectFit: "contain"}}/>
            )
        },
        {
            title: '欢迎页标题',
            dataIndex: 'title',
            key: 'title',
            width: 200
        },
        {
            title: '时长（S）',
            dataIndex: 'duration',
            key: 'duration',
            width: 120
        },
        {
            title: '链接类型',
            dataIndex: 'type',
            key: 'type',
            ellipsis: true,
            render: (text, record) => {
                return (
                    <>
                        {(() => {
                            switch (text) {
                                case 1: return "内部链接";
                                case 2: return "外部链接";
                                case 3: return "无链接";
                                default: return "-";
                            }
                        })()}
                    </>
                )
            },
            width: 120
        },
        {
            title: '跳转地址',
            dataIndex: 'url',
            key: 'url',
            width: 400,
            render: (text, record) => (
                <>
                    <span style={{wordBreak: "break-all"}}>{text ? text : "-"}</span>
                </>
            )
        },
        {
            title: '当前欢迎页',
            dataIndex: 'defaultFlag',
            key: 'defaultFlag',
            render: (text, record) => {
                return text ? "启用" : "禁用"
            },
            width: 120
        },
        {
            title: '操作',
            dataIndex: 'option',
            key: 'option',
            width: 200,
            render: (text, record) =>{
                return (<span>
                    <Button style={{padding: "0 5px"}} type={"link"} onClick={() => this.edit(record)}>编辑</Button>
                    <Popconfirm key={uuid()} placement="topLeft" title={"删除后不可恢复，您确定删除这条欢迎页吗？"}
                                    onConfirm={() => this.deleteById(record.id)} okText="是" cancelText="否">
                            <Button style={{padding: "0 5px", marginLeft: 15}} type={"link"}>删除</Button>
                        </Popconfirm>
            </span>)
            }
        }
    ];

    state = {
        total : 0,
        dataSource : [],
        title: ""
    };

    params = {
        type : 0,
        queryStr:"",
        start: 1,
        size: 10
    };

    defaultParams = {
        start: 1,
        size: 10
    };

    componentDidMount() {
        this.loadData(this.params)
    }

    loadData = (body) =>{
        let url = "/cm-sites-mmp/splash/pageList";
        this.request({
            url, body, callBack:(res)=>{
                if(res){
                    this.setState({
                        total: res.count,
                        dataSource: res.data
                    })
                }
            }
        });
    };

    pageChange = (page, pageSize) => {
        this.updateTableData(page, pageSize);
    };

    onShowSizeChange = (current, size) => {
        this.updateTableData(current, size);
    };

    updateTableData = (start, size) =>{
        this.params = {
            ...this.params,
            start: start,
            size:size
        };
        this.loadData(this.params);
    };

    edit = (record) =>{
        this.refs.splashDetail.showModal(record,this.updateTableData, "欢迎页详情");
    };

    deleteById = (id) =>{
        window.loading.show();
        let url = '/cm-sites-mmp/splash/delete';
        this.request({
            url, body:{id}, callBack: ()=>{
                this.updateTableData(this.defaultParams.start, this.defaultParams.size)
            }
        });
    };

    insert = () =>{
        this.refs.splashDetail.showModal({id:null, duration: 5, type: 1},this.updateTableData, "新增欢迎页");
    };

    renderPage(){
        let {total}=this.state;
        let {start, size} = this.params;
        if(!total) return <div style={{height:81}}/>;
        return(
            <div style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                borderTop: '1px solid #eee',
                padding: '10px 0px 10px 10px',}}
            >
                <Pagination
                    size="middle"
                    total={total}
                    showTotal={(total) => `共有${total}条数据`}
                    showSizeChanger
                    showQuickJumper
                    current={start}
                    pageSize={size}
                    onChange={(page,pageSize)=>{this.onShowSizeChange(page, pageSize)}} //页码改变时回调
                    onShowSizeChange={(page,pageSize)=>{this.onShowSizeChange(1, pageSize)}} //每页条数改变回调
                />
            </div>
        )
    }

    render() {
        return (
            <>
                <Card
                    style={{ margin:15, borderRadius:5, maxHeight: "calc(100vh - 100px)" }}
                    className={"splashCard"}
                >
                    <div style={{display: "flex", alignItems: "center"}}>
                        <Search placeholder={"请输入欢迎页标题"}
                                style={{width: 250, marginRight: "20px"}}
                                value={this.params.queryStr}
                                onChange={(e) => {
                                    this.params.queryStr = e.target.value;
                                    this.setState({})
                                }}
                                onSearch={(queryStr) => {
                                    this.params.queryStr = queryStr;
                                    this.params.start = 1;
                                    this.setState({}, () => {
                                        this.loadData(this.params)
                                    })
                                }}/>
                        <Button style={{marginRight: "20px"}} onClick={() => {
                            this.params = {
                                type: 0,
                                queryStr: "",
                                start: 1,
                                size: 10
                            };
                            this.setState({}, () => {
                                this.loadData(this.params);
                            })
                        }} type={"primary"}>
                            重置
                        </Button>
                    </div>
                    <Button type="primary" onClick={() => this.insert(0)} style={{marginBottom: 24, marginTop: 20}}>新增</Button>
                    <SplashDetail ref={"splashDetail"}/>
                    <Scrollbars autoHide autoHeight autoHeightMax={"calc(100vh - 286px)"}>
                        <BaseTable dataSource={this.state.dataSource} columns={this.columns} />
                    </Scrollbars>
                    {this.renderPage()}
                </Card>
                <style>{`.splashCard .ant-card-body{padding: 24px 15px;zoom: 1;}`}</style>
            </>
        )
    }
}

class SplashDetail extends BaseComponent{

    state = {
        fieldData: {},
        visible : false,
        spinLoading : false
    };

    okCallBack = () =>{};

    showModal = (fieldData, okCallBack, title) => {
        this.setState({
            visible: true,
            title,
            fieldData: (()=>{
                if(!fieldData){
                    return null;
                }
                let value = {};
                for(let attr in fieldData){
                    value[attr] = {
                        value: fieldData[attr]
                    }
                }
                return value;
            })()
        });
        this.okCallBack = okCallBack;
    };

    handleOk = (e) => {
        this.setState({
            confirmLoading: true,
        });

        let that = this;
        let wrappedSplashModalForm = this.refs.wrappedSplashModalForm;//通过refs属性可以获得对话框内form对象
        wrappedSplashModalForm.validateFields((err, values) => {
            if(!err){
                let url = "/cm-sites-mmp/splash/insert";
                if(values.id){
                    url = "/cm-sites-mmp/splash/update";
                }
                if(!values.url) values.url = "";
                that.request({
                    url, body: {...values}, method:"post", contentType:"json", callBack:()=>{
                        that.setState({
                            visible: false,
                            spinLoading: false,
                        });
                        wrappedSplashModalForm.resetFields();
                        that.okCallBack(1,10);
                    }
                });
            }else{
                this.setState({
                    spinLoading: false,
                });
            }
        });
    };

    handleCancel = () => {
        let wrappedSplashModalForm = this.refs.wrappedSplashModalForm;
        wrappedSplashModalForm.resetFields();
        this.setState({
            visible: false,
        });
    };

    render() {
        return(
            <Modal
                title={this.state.title}
                visible={this.state.visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                destroyOnClose={true}
                maskClosable={false}
                okText={"提交"}
                width={800}
            ><Spin spinning={this.state.spinLoading}>
                <WrappedSplashModalForm fieldData={this.state.fieldData} ref={"wrappedSplashModalForm"}/>
            </Spin>
            </Modal>)
    }
}

/** 表单 */
class SplashModalForm extends React.Component{

    state = {
    };

    componentDidMount() {
        this.initFields(this.props);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.initFields(nextProps);
    }

    fieldData;

    initFields(props) {
        const { fieldData } = props;
        const { setFields } = props.form;

        if(fieldData && this.fieldData !== fieldData){
            this.fieldData = fieldData;
            setFields(fieldData);
        }
    }

    changeImageUrl = (file) => {
        const { setFieldsValue } = this.props.form;
        let fileInfo = file.response;
        setFieldsValue({"storageUrl":fileInfo.data.path});
    };

    changeDefault = (value) =>{
        const { setFieldsValue } = this.props.form;
        setFieldsValue({"defaultFlag":value});
    };

    render() {
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 }
        };
        const { getFieldDecorator } = this.props.form;
        let dataForm = this.props.form.getFieldsValue();
        console.log(dataForm)
        return (
            <Form {...formItemLayout}>
                {getFieldDecorator('id',{
                    initialValue:0
                })(
                    <Input type={"hidden"} />
                )}
                <Form.Item label="欢迎页标题">
                    {getFieldDecorator('title', {
                        rules: [{ required: true, message: '请输入欢迎页标题!'}, {max:20, message:"最大长度不能超过20字"}],
                    })(
                        <Input placeholder="请输入欢迎页标题" />
                    )}
                </Form.Item>
                <Form.Item label="时长（S）">
                    {getFieldDecorator('duration', {
                        rules: [{ required: true, message: '请输入时长!' }],
                    })(
                        <InputNumber min={1} max={10} defaultValue={this.props.fieldData.duration ? this.props.fieldData.duration.value : ""} />
                    )}
                </Form.Item>
                <Form.Item
                    name="storageUrl"
                    label="欢迎页图片"
                >
                    <Avatar storageUrl={this.props.fieldData.storageUrl ? this.props.fieldData.storageUrl.value : ""} changeImage={(file) => this.changeImageUrl(file)} />
                    {getFieldDecorator('storageUrl', {
                        rules: [{ required: true, message: '请上传欢迎页图片!' }],
                    })(
                        <Input type={"hidden"} />
                    )}
                </Form.Item>
                <Form.Item label="链接类型">
                    {getFieldDecorator('type')(
                        <Radio.Group>
                            <Radio value={1}>内部链接</Radio>
                            <Radio value={2}>外部链接</Radio>
                            <Radio value={3}>无链接</Radio>
                        </Radio.Group>
                    )}
                </Form.Item>
                {dataForm.type === 3 ? null :
                    <Form.Item label="链接地址">
                        {getFieldDecorator('url', {
                            rules: [{ required: dataForm.type !== 1, message: '请输入正确的链接地址!' , pattern : dataForm.type === 1 ? null : new RegExp(/http[s]{0,1}:\/\/([\w.]+\/?)\S*/)}],
                        })(
                            <Input placeholder="请输入链接地址" />
                        )}
                    </Form.Item>}
                <Form.Item label="当前欢迎页">
                    {getFieldDecorator('defaultFlag')(
                        <Input type={"hidden"}/>
                    )}
                    <Switch onChange={this.changeDefault} defaultChecked={this.props.fieldData.defaultFlag ? this.props.fieldData.defaultFlag.value : ""}/>
                </Form.Item>
            </Form>
        );
    }
}

const WrappedSplashModalForm = Form.create()(SplashModalForm);

function beforeUpload(file) {
    const isJpgOrPng = file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/bmp' || file.type === 'image/png';
    if (!isJpgOrPng) {
        message.error('暂不支持该文件类型！');
        return false;
    }
    const isLt2M = file.size / 1024 / 1024 < 20;
    if (!isLt2M) {
        message.error('图片大小必须小于20MB！');
        return false;
    }
    return isJpgOrPng && isLt2M;
}

class Avatar extends React.Component {

    state = {
        loading: false,
        imageUrl: this.props.storageUrl
    };

    handleChange = info => {
        if (info.file.status === 'uploading') {
            this.setState({ loading: true });
            return;
        }
        if (info.file.status === 'done') {
            this.setState({
                imageUrl:info.file.response.data.path
            });
            this.props.changeImage(info.file);
        }
    };

    render() {
        const { imageUrl } = this.state;
        const uploadButton = (
            <div>
                <div style={{ marginTop: 8 }}><Icon type="plus" /></div>
            </div>
        );
        return (
            <Upload
                accept={"." + ONLY_PIC_TYPE_NEW.join(",.")}
                name="file"
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={false}
                action="/storage/uploadFile"
                beforeUpload={beforeUpload}
                onChange={this.handleChange}
            >
                {imageUrl ? <img src={imageUrl} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
            </Upload>
        );
    }
}

export default Splash;
